import styled from "styled-components";

import { ErrorContainer } from "src/shared/components/ErrorCaught/styled";
import ContactBox from "src/shared/contact-boxes/components/ContactBox";

export const ErrorContactBox = styled(ContactBox)`
  ${ErrorContainer} {
    min-height: 300px;
  }
`;
